'use strict';

import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes';

export default class LazyImages {
    constructor() {}
}



// WEBPACK FOOTER //
// ./components/lazyimages/scripts/lazyimages.js